<template>
  <div class="productsList" v-if="productList.length">
    <p v-if="listTitle.length">{{listTitle}}</p>
    <ul
      :class="{listTypeBest: listTypeBest}"
    >
      <li
        class="productItem"
        v-for="(product, index) in productList"
        :key="index"
      >
        <product-item
          :product="product"
          :isCartbuttonVisible="isCartbuttonVisible(product.type)"
          :isRewardUse="isRewardUse"
        ></product-item>
      </li>
    </ul>
    <button
      type="button"
      class="btMore"
      v-show="isMore"
      @click="$emit('getMoreList', collectionIndex)"
    ><span class="icon iconMore"></span>더보기</button>
  </div>
</template>

<script>
import ProductItem from '@/views/base/ProductItem'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductsList',
  components: {
    ProductItem
  },
  props: {
    listTitle: {
      type: String,
      default: ''
    },
    productList: {
      type: Array,
      default: () => []
    },
    isMore: {
      type: Boolean,
      default: false
    },
    collectionIndex: {
      // 홈 메뉴의 collection을 위해 사용
      type: Number,
      default: -1
    },
    listTypeBest: {
      type: Boolean,
      default: false
    },
    isNewList: {
      type: Boolean,
      default: false
    },
    isRewardUse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("main", ["enableCart"]),
  },
  methods: {
    isCartbuttonVisible(type) {
      return !(!this.enableCart || type === 3 || type === 4);
    }
  }
}
</script>

<style lang="scss">
</style>

